import React  from 'react';
import PropTypes from 'prop-types';
import { Tab, TabList, TabPanel } from 'react-tabs';
import css from './css/StudentSurveyTabs.scss';
import AccessibleTabs from 'common/AccessibleTabs';

/*
  Creates tabs for the different steps in the student survey setup.
*/
function StudentSurveyTabs({ children, onSelect, selectedTab, tabs }) {
    return (
        <AccessibleTabs className={css['container']}
                        onSelect={onSelect}
                        selectedIndex={selectedTab}
                        selectedTabClassName={css['tab-selected']}
                        selectedTabPanelClassName={css['panel']}>
            <TabList className={css['list-container']}>
                { tabs.map(tab => <Tab data-testid={tab.id} key={tab.id}>{tab.name}</Tab>) }
            </TabList>
            { children.map((tabPanel, idx) => tabPanel && <TabPanel key={idx}>{tabPanel}</TabPanel>) }
        </AccessibleTabs>
    );
}

StudentSurveyTabs.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedTab: PropTypes.number.isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string
    })),
    children: PropTypes.arrayOf(PropTypes.node).isRequired
};

export default StudentSurveyTabs;

